import Keycloak from "keycloak-js";
import { useAuthStore } from "../store/authStore";
import { storeToRefs } from "pinia";
import { toRaw } from "vue";

let data;
// let authenticated;
// let store = null;

const authenticated = false;

let keycloakObj: Keycloak;

function getKeycloakObj() {
  const options = {
    url: import.meta.env.VITE_KEYCLOAK_API_BASE_URL,
    // for remote server
    // clientId: "cleverreach-app-authentication"
    // for local server
    clientId: import.meta.env.VITE_KEYCLOAK_CLIENT_ID,
    realm: import.meta.env.VITE_KEYCLOAK_REALM,
  };
  if (!keycloakObj) {
    keycloakObj = new Keycloak(options);
  }
  return keycloakObj;
}

/**
 * Initializes store with Keycloak user data
 *
 */
async function saveLoginKeycloak() {
  try {
    useAuthStore().storeLogin(keycloakObj);
    await useAuthStore().retrieveUserData();

    // Show alert if user is not authenticated
    if (!authenticated) {
      return false;
    }
  } catch (error) {
    console.error("Keycloak init failed: ", error);
    return false;
  }
}

/**
 * Initializes Keycloak, then run callback. This will prompt you to login.
 *
 * @param onAuthenticatedCallback
 */
async function initKeycloak(callback?: any) {
  try {
    // keycloak = new Keycloak(options);
    console.log("initKeykloak-called");

    const authenticated = await keycloakObj
      .init({
        enableLogging: true,
        checkLoginIframe: false,
        onLoad: "login-required",
      })
      .then((authenticated) => {
        console.log("initKeykloak-authenticated=", authenticated);
        if (authenticated) {
          saveLoginKeycloak();
          if (callback) {
            callback();
          }
          return true;
        } else {
          return false;
        }
      })
      .catch((error) => {
        console.error("Keycloak auth failed: ", error);
        return false;
      });
    console.log("is authenticated=", authenticated, keycloakObj);
    return false;

    // onInitCallback()
  } catch (error) {
    console.error("Keycloak init failed: ", error);
    return false;
  }
  return false;
}

async function updateAccessToken() {
  try {
    const keycloakObj = toRaw(useAuthStore().getKeycloakObj);

    const exp = keycloakObj?.idTokenParsed?.exp;
    const auth = keycloakObj?.idTokenParsed?.auth_time;

    try {
      const date = new Date(exp * 1000);
      console.log("date=", date);
      const auth_date = new Date(auth * 1000);
      console.log("auth_date=", auth_date);
      if (date < new Date()) {
        console.log("token expired, updating it");
        await keycloakObj.updateToken(-1);
      }
    } catch {}
  } catch {}
}

function getAccessToken(): string {
  try {
    // keycloak = new Keycloak(options);
    // const keycloak1=useAuthStore().getKeycloakObj;
    const keycloakObj = toRaw(useAuthStore().getKeycloakObj);

    // const mystore = useAuthStore();
    // mystore.setKeycloakObj(keycloak2);

    return (keycloakObj as Keycloak).token;

    // onInitCallback()
  } catch (error) {
    console.error("Keycloak init failed: ", error);
    return "";
  }
}

async function initKeycloakByKeycloakObj(keycloakObj: any) {
  try {
    // keycloak = new Keycloak(options);
    // const keycloak1=useAuthStore().getKeycloakObj;
    const keycloak2 = toRaw(useAuthStore().getKeycloakObj);
    await keycloak2
      .init({
        enableLogging: true,
        checkLoginIframe: false,
        onLoad: "login-required",
      })
      .then((authenticated: boolean) => {
        if (authenticated) {
          return true;
        } else {
          return false;
        }
      })
      .catch((error: any) => {
        return false;
      });

    if (keycloak2.authenticated) {
      useAuthStore().storeLogin(keycloak2);
      await useAuthStore().retrieveUserData();
    }
    // const mystore = useAuthStore();
    // mystore.setKeycloakObj(keycloak2);

    return keycloak2.authenticated;

    // onInitCallback()
  } catch (error) {
    console.error("Keycloak init failed: ", error);
    return false;
  }
  return false;
}

async function loginKeycloak(callback: Function) {
  keycloakObj
    .login()
    .then((d) => {
      console.log("login: ", d);
      saveLoginKeycloak();
      callback();
    })
    .catch((err) => console.log("login-err=", err));
}

/**
 * Logout user
 */
async function logoutKeycloak(redirectUri?: string) {
  // let params = {}
  // if (redirectUri) {
  //   params = { redirectUri: redirectUri };
  // }
  useAuthStore().clearUserData();

  keycloakObj.logout();
  // .then(d => {
  //   console.log("logout: ",d);
  // }).catch(err => console.log("logout-err=",err));;
}

/**
 * Refreshes token
 */
async function refreshKeycloakToken() {
  try {
    await keycloakObj.updateToken(480);
    return keycloakObj;
  } catch (error) {
    console.error("Failed to refresh token");
    console.error(error);
  }
}

const KeycloakService = {
  initKeycloak: initKeycloak,
  loginKeycloak: loginKeycloak,
  logoutKeycloak: logoutKeycloak,
  refreshKeycloakToken: refreshKeycloakToken,
  keycloakObj: keycloakObj,
  authenticated: authenticated,
  getKeycloakObj: getKeycloakObj,
  initKeycloakByKeycloakObj,
  getAccessToken,
  updateAccessToken,
};

export default KeycloakService;
